import React from 'react';

export const CropIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 4H4v4m16 8v4h-4M4 8h12a2 2 0 012 2v8" />
    </svg>
);